import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Button from '@mui/material/Button'

import img from 'resources/images/tradeImg.jpg'
import getLocalizedPath from 'utils/localizedPath'
export default function About() {
    const {
        t,
        i18n: { language },
    } = useTranslation()
    const navigate = useNavigate()
    const aboutUsPath = getLocalizedPath('/about-us', language)

    return (
        <div className='bg-[#f7f7f8]'>
            <div className='py-8 flex gap-5 bg-container flex-col  md:py-[50px] md:gap-6 lg:gap-10 lg:py-[80px] lg:flex-row'>
                <div
                    onClick={() => navigate(aboutUsPath)}
                    className='w-full cursor-pointer h-auto rounded-[10px] overflow-hidden lg:w-1/2'
                >
                    <img
                        src={img}
                        className='w-full h-full object-cover hover:scale-105 transition-all duration-500 ease-in-out'
                        alt={t('home.aboutTitle')}
                    />
                </div>
                <div className='text-base font-medium text-[#333d47] md:text-lg lg:flex-1'>
                    <h2 className='text-3xl pb-4 font-bold'>{t('home.aboutTitle')}</h2>
                    <p className='pb-6'>{t('home.about')}</p>
                    <Button onClick={() => navigate(aboutUsPath)} variant='primaryRed'>
                        {t('home.seeMore')}
                    </Button>
                </div>
            </div>
        </div>
    )
}
